<template>
  <v-card
    light
    :to="path"
    class="flex d-flex flex-column"
    :dark="dark"
    height="100%"
  >
    <v-card-title>
      <h2 class="headline">{{ title }}</h2>
    </v-card-title>
    <v-card-subtitle>
      <p class="overline mt-2">{{ type }}</p>
      {{ description }}
    </v-card-subtitle>
    <v-card-actions>
      <v-btn color="amber" light class="mb-2 ml-2">{{ button }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
// @ is an alias to /src
export default {
  name: "AdminCard",
  props: {
    title: String,
    type: String,
    description: String,
    path: String,
    button: {
      type: String,
      default: "Start",
    },
    dark: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
